// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { Message } from '@shared/utils/DirectMessages/Message';
import { PFixMessage } from './PFixMessage';
export class BrokerResponseMessage extends PFixMessage {
    constructor(fieldSet) {
        super(Message.CODE_PFIX_BROKER_RESPONSE_MESSAGE, fieldSet);
    }
    setId(id) {
        this.setFieldValue(FieldsFactory.FIELD_ID, id);
    }
    setValue(value) {
        this.setFieldValue(FieldsFactory.FIELD_VALUE, value);
    }
    setUserID(userID) {
        this.setFieldValue(FieldsFactory.FIELD_USER_ID, userID);
    }
    setUsername(userName) {
        this.setFieldValue(FieldsFactory.FIELD_LOGIN, userName);
    }
    setResponseType(responseType) {
        this.setFieldValue(FieldsFactory.FIELD_BROKER_MESSAGE_RESPONSE_TYPE, responseType);
    }
}
